import type { FC } from 'react'

import clsx from 'clsx'

import { CreateObjectFieldCard } from 'entities/kyrgyzstan/ui/create-object'

import type { CreateObjectDynamicField } from 'shared/api/kyrgyzstan/create-object'
import { ButtonInputValue } from 'shared/ui/button-input-value'
import { InputWithLabel } from 'shared/ui/input-label'
import { Paper } from 'shared/ui/paper'
import { Switch } from 'shared/ui/switch'

import s from './styles.module.scss'

interface DynamicFieldControlProps {
  field: CreateObjectDynamicField
  value: string
  disabled: boolean
  onChange: (fieldId: number, value: string) => void
}

export const DynamicFieldControl: FC<DynamicFieldControlProps> = ({
  field,
  value,
  disabled,
  onChange,
}) => {
  if (field.field_type === 'boolean') {
    return (
      <Paper
        padding={[12, 16]}
        className={s.booleanField}
      >
        <p className={clsx(s.booleanLabel, 'bold-16')}>{field.name}</p>
        <Switch
          isChecked={value === 'true'}
          disabled={disabled}
          onChange={(isChecked) => onChange(field.id, isChecked ? 'true' : '')}
        />
      </Paper>
    )
  }

  if (field.field_type === 'number') {
    const numberValue = Number(value)

    return (
      <Paper
        padding={[12, 16]}
        className={clsx(disabled && s.disabledField)}
      >
        <ButtonInputValue
          title={field.name}
          value={Number.isFinite(numberValue) ? numberValue : 0}
          maxNumber={Number.MAX_SAFE_INTEGER}
          onChange={(nextValue) => onChange(field.id, String(nextValue))}
        />
      </Paper>
    )
  }

  if (field.field_type === 'text') {
    return (
      <CreateObjectFieldCard title={field.name}>
        <InputWithLabel
          label={field.name}
          variant="secondary"
          value={value}
          type="text"
          disabled={disabled}
          onChange={(event) => onChange(field.id, event.target.value)}
        />
      </CreateObjectFieldCard>
    )
  }

  return null
}
